import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "./Offering.css";
import Testimonial from "../../../Testimonial/Testimonial";

const Offering = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    // Set initial container width
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed (pixels per frame)

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

const offerings = [
  {
    id: 1,
    title: "Web Development",
    description:
      "Custom web applications built with modern technologies for optimal performance and scalability.",
    icon: "💻",
  },
  {
    id: 2,
    title: "Mobile App Development",
    description:
      "Native and cross-platform mobile applications for iOS and Android devices.",
    icon: "📱",
  },
  {
    id: 3,
    title: "UI/UX Design",
    description:
      "User-centered design solutions that enhance engagement and improve conversion rates.",
    icon: "🎨",
  },
  {
    id: 4,
    title: "Cloud Solutions",
    description:
      "Secure and reliable cloud infrastructure tailored to your business needs.",
    icon: "☁️",
  },
  {
    id: 5,
    title: "Digital Marketing",
    description:
      "Data-driven marketing strategies to increase your online presence and reach.",
    icon: "📊",
  },
  {
    id: 6,
    title: "IT Consulting",
    description:
      "Expert advice to align your technology with business objectives for maximum ROI.",
    icon: "👨‍💼",
  },
  {
    id: 7,
    title: "CRM Software",
    description:
      "Streamline customer interactions, sales, and support with powerful CRM solutions.",
    icon: "🤝",
  },
  {
    id: 8,
    title: "Custom Software Development",
    description:
      "Tailor-made software applications designed to meet your unique business needs.",
    icon: "🛠️",
  },
  {
    id: 9,
    title: "Artificial Intelligence & Machine Learning",
    description:
      "Smart AI-driven solutions that automate processes, enhance decision-making, and deliver insights.",
    icon: "🤖",
  },
  {
    id: 10,
    title: "Cybersecurity Solutions",
    description:
      "End-to-end security services to protect your business from cyber threats and vulnerabilities.",
    icon: "🔒",
  },
  {
    id: 11,
    title: "Data Analytics & Business Intelligence",
    description:
      "Transform raw data into actionable insights with advanced analytics and BI dashboards.",
    icon: "📈",
  },
  {
    id: 12,
    title: "ERP Solutions",
    description:
      "Integrated ERP systems to streamline operations, finance, and supply chain management.",
    icon: "🏢",
  },
  {
    id: 13,
    title: "E-Commerce Development",
    description:
      "Robust and scalable e-commerce platforms that provide seamless shopping experiences.",
    icon: "🛒",
  },
  {
    id: 14,
    title: "DevOps & Automation",
    description:
      "Accelerate software delivery and improve efficiency with DevOps practices and automation tools.",
    icon: "⚙️",
  },
  {
    id: 15,
    title: "Blockchain Solutions",
    description:
      "Decentralized applications, smart contracts, and blockchain integrations for secure digital ecosystems.",
    icon: "⛓️",
  },
  {
    id: 16,
    title: "IoT Solutions",
    description:
      "Connect devices, collect data, and enable smarter business operations with Internet of Things technology.",
    icon: "📡",
  },
  {
    id: 17,
    title: "Augmented & Virtual Reality",
    description:
      "Immersive AR/VR solutions for gaming, training, retail, and enterprise applications.",
    icon: "🕶️",
  },
  {
    id: 18,
    title: "Quality Assurance & Testing",
    description:
      "Comprehensive testing services to ensure your applications are reliable, secure, and bug-free.",
    icon: "🧪",
  },
  {
    id: 19,
    title: "Managed IT Support",
    description:
      "Proactive IT support and maintenance services to keep your business running smoothly.",
    icon: "🛡️",
  },
  {
    id: 20,
    title: "Technology Training & Workshops",
    description:
      "Upskill your team with hands-on training programs in the latest tools and technologies.",
    icon: "📚",
  },
  {
    id: 21,
    title: "Product Engineering",
    description:
      "End-to-end product design, development, and lifecycle management services.",
    icon: "🚀",
  },
  {
    id: 22,
    title: "Cloud-Native Application Development",
    description:
      "Build and deploy cloud-native apps with microservices and container-based architectures.",
    icon: "☁️⚡",
  },
  {
    id: 23,
    title: "API Integration Services",
    description:
      "Seamlessly connect applications and services with robust API integration solutions.",
    icon: "🔗",
  },
  {
    id: 24,
    title: "Robotic Process Automation (RPA)",
    description:
      "Automate repetitive business processes with RPA bots to improve efficiency and reduce costs.",
    icon: "🤖⚙️",
  },
];
 

  return (
    <div>
      <Helmet>
        <title>Our Technology Offerings | Comprehensive Digital Solutions</title>
        <meta 
          name="description" 
          content="Explore our wide range of technology offerings and services powered by cutting-edge tools and frameworks for digital transformation." 
        />
        <meta 
          name="keywords" 
          content="technology offerings, digital solutions, software services, tech stack, web development, mobile development, cloud solutions, enterprise software" 
        />
      </Helmet>
      

          <div className="mk-offerings-container">
      <div className="mk-offerings-hero">
        <h1 className="mk-offerings-title">Our Offerings</h1>
        <p className="mk-offerings-subtitle">Comprehensive technology solutions to drive your business forward</p>
      </div>
      
      <div className="mk-offerings-grid">
        {offerings.map((service) => (
          <div key={service.id} className="mk-service-card">
            <div className="mk-service-icon">{service.icon}</div>
            <h3 className="mk-service-title">{service.title}</h3>
            <p className="mk-service-desc">{service.description}</p>
            <button className="mk-service-cta">Learn More</button>
          </div>
        ))}
      </div>
      
      <div className="mk-offerings-cta">
        <h2>Ready to transform your business?</h2>
        <p>Contact us today to discuss how our offerings can help you achieve your goals</p>
        <a
  href="https://wa.me/919155599968?text=Hi!%20I%20would%20like%20to%20know%20more%20about%20your%20offerings%20and%20services.%20Please%20connect%20me%20with%20your%20team."
  target="_blank"
  rel="noreferrer"
>
  <button className="mk-primary-cta">Get in Touch</button>
</a>

      </div>
    </div>
      
      <Testimonial />

      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Offering;